module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "CloudChainView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CloudChainView!./src/pages/Shop/Member/Personal/CloudChain/CloudChainView/index.js
// module id = 1110
// module chunks = 431